export enum Locale {
  daDK = 'da-DK',
  deAT = 'de-AT',
  deCH = 'de-CH',
  deDE = 'de-DE',
  enAU = 'en-AU',
  enCA = 'en-CA',
  enCH = 'en-CH',
  enGB = 'en-GB',
  enJP = 'en-JP',
  enPT = 'en-PT',
  enUS = 'en-US',
  esES = 'es-ES',
  fiFI = 'fi-FI',
  frBE = 'fr-BE',
  frCA = 'fr-CA',
  frFR = 'fr-FR',
  hrHR = 'hr-HR',
  jaJP = 'ja-JP',
  nlNL = 'nl-NL',
  noNO = 'no-NO',
  plPL = 'pl-PL',
  ptPT = 'pt-PT',
  ruRU = 'ru-RU',
  srRS = 'sr-RS',
  svSE = 'sv-SE',
}
